import { render, staticRenderFns } from "./updateprofile.vue?vue&type=template&id=6e007bf3&scoped=true&"
import script from "./updateprofile.vue?vue&type=script&lang=js&"
export * from "./updateprofile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e007bf3",
  null
  
)

export default component.exports